import axios, { AxiosError } from "axios";

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export const apiClient = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

// Attach the CSRF token (double-submit cookie) to every state-changing
// request. The cookie is set automatically by the server on first request.
apiClient.interceptors.request.use((config) => {
  const method = (config.method ?? "get").toUpperCase();
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const token = readCookie("csrf_token");
    if (token) {
      config.headers.set("x-csrf-token", token);
    }
  }
  return config;
});

export interface ApiErrorShape {
  error: string;
  details?: unknown;
}

export function getApiErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const axiosErr = err as AxiosError<ApiErrorShape>;
    return axiosErr.response?.data?.error ?? axiosErr.message ?? "Something went wrong";
  }
  if (err instanceof Error) return err.message;
  return "Something went wrong";
}
